module.exports = __webpack_public_path__ + "static/about-profile-henryl-f7b482f791fac1a174c45923749741fa.png";